import { ChangeEvent, useEffect, useState } from "react"
import { Report } from "../../interfaces/intakes.reports"
import { jsonKeyToString } from "../../helpers/jsonToString"
import { mainDataValue } from "../../helpers/mainDataConvert"
import { arrayCheckedToObject, objectToCheckArray } from "../../helpers/objToArray"
import { PDFMainData } from "../ui/ModalSendPDF"

interface Props {
  report: Report
  finalReport: Report
  setFinalReport: (report:Report) => void
}
export const PDF_STEPS_MAINDATA = ({ report, finalReport, setFinalReport }: Props) => {

  const [PDFMainData, setPDFMainData] = useState<PDFMainData[]>([])

  useEffect(() => {
    //Agregar los check = true si existe en finalReport
    setPDFMainData(report.mainData && objectToCheckArray(report.mainData, finalReport.mainData))
  }, [report])
  

  const handleCheck = (e:ChangeEvent<HTMLInputElement>, item: any) => {
        const newMainData = PDFMainData.map(info => {
            if (info.key === item.key) {
                return {
                    ...info,
                    check: e.target.checked
                }
            } else {
                return info
            }
        })
        setPDFMainData(newMainData)

        const checkedItems = newMainData.filter(item => item.check === true)

        setFinalReport({
          ...finalReport,
          mainData: arrayCheckedToObject(checkedItems)
        })
        
    }


  return (
    <>
      <h4 className='mb-2'>Select the data to display</h4>
      <div className='mb-3'>
        {
          report.mainData && PDFMainData.length > 0 &&
          PDFMainData.map((item:any) => (
            <div key={item.key} className='main-info__item mb-05'>
              <div className='flex'>
                <input
                  className='check-on-off'
                  type="checkbox"
                  checked={item.check}
                  onChange={(e) => handleCheck(e, item)}
                />
                <p className='font-normal'>{jsonKeyToString(item.key)}</p>
              </div>

              <p className='bold font-normal'>{mainDataValue(item.key, item.value)}</p>
            </div>
          ))
        }
      </div>
    </>
  )
}
